import React from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import AuthCallback from "./AuthCallback";
import AdminLogin from "./AdminLogin";
import AdminDashboard from "./AdminDashboard";

export default function AdminPage() {
  const location = useLocation();
  const { user, loading } = useAuth();

  // Process OAuth callback first (synchronous read of reactive hash)
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  if (loading) {
    return <div className="flex min-h-screen items-center justify-center bg-[#F9F6F0]"><p className="text-[#5C6370]">Chargement…</p></div>;
  }
  if (user && user.role === "admin") return <AdminDashboard />;
  return <AdminLogin />;
}
